export default (theme) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    main: {
        margin: '12px 0 24px',
        display: 'flex',
        flexFlow: 'row nowrap',
        gap: 40,
        alignItems: 'center',
        paddingRight: 2,
        '& > *': {
            flex: 1,
        },
    },
    pic: {
        aspectRatio: 16 / 9,
        backgroundColor: theme.colors.background.utility025,
        borderRadius: 12,
        boxShadow:
            '0px 0px 2px rgba(39, 60, 80, 0.14), 0px 2px 2px rgba(39, 60, 80, 0.12), 0px 1px 3px rgba(39, 60, 80, 0.2)',
        overflow: 'hidden',
        '& > *': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            border: 0,
        },
    },
});
